module.exports = __webpack_public_path__ + "img/banner.d923dd90.png";